import { PropertyPanel, parseQueryString, resolveUrl, serviceCall } from "@serenity-is/corelib";
import { Texts } from "../ServerTypes/Texts";
import { ElevateRequest } from "../ServerTypes/Pro/Extensions.ElevateRequest";
import { ElevateForm } from "../ServerTypes/Pro/Extensions.ElevateForm";

const myTexts = Texts.Forms.Membership.Elevation;

export default function pageInit() {
    new ElevationPanel({ element: '#PanelDiv' }).domNode?.classList.add("d-flex", "flex-grow-1", "align-items-center");
}

export class ElevationPanel extends PropertyPanel<ElevateRequest, any> {

    protected getFormKey() {
        return ElevateForm.formKey;
    }

    protected getReturnUrl() {
        var q = parseQueryString();
        return q['returnUrl'] || q['ReturnUrl'];
    }

    protected redirectToReturnUrl() {
        var returnUrl = this.getReturnUrl();
        if (returnUrl && /^\//.test(returnUrl)) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;
        }
        else {
            window.location.href = resolveUrl('~/');
        }
    }

    submitClick() {
        if (!this.validateForm()) {
            return;
        }

        var request = this.propertyGrid.save();

        serviceCall({
            url: resolveUrl('~/Account/Elevate'),
            request,
            onSuccess: () => {
                this.redirectToReturnUrl()
            }
        });
    }

    renderContents(): any {
        const id = this.useIdPrefix();
        return (
            <div class="s-container-tight">
                <div class="s-Panel p-4">
                    <h5 class="text-center mb-4">{myTexts.ConfirmAccess}</h5>
                    <p class="text-center">{myTexts.ActionRequiresElevation}</p>
                    <form id={id.Form} action="">
                        <div id={id.PropertyGrid}></div>
                        <button id={id.SubmitButton} type="submit" class="btn btn-primary my-3 mx-8 w-100"
                            onClick={e => {
                                e.preventDefault();
                                this.submitClick()
                            }}>
                            {myTexts.ElevateButton}
                        </button>
                    </form>
                </div>
            </div>
        )
    }
}

